<template>
  <div class="tab-list" ref="tabContainer">
    <div
      :class="['home-tab-item', currentTab?.routeUrl === homeItem.routeUrl ? 'is-active' : '']"
      @click="handleHomeTab"
    >
      <span>{{ homeItem.name }}</span>
      <!-- <i class="el-icon-close" @click.stop="handleClose(item, index)"></i> -->
      <el-icon style="margin-left: 10px" @click.stop="handleClose(item, index)"><House /></el-icon>
    </div>
    <div
      v-for="(item, index) in allMenuList"
      :key="item.routeUrl"
      :class="[
        'tab-item',
        currentTab?.routeUrl === item.routeUrl ? 'is-active' : '',
        index >= tabNum1 ? 'is-hidden' : ''
      ]"
      @click="handleChangeTab(item)"
      @contextmenu.prevent="rightClick($event, { item, index })"
      draggable="true"
      @dragstart="onDragStartHandler(index, $event)"
      @dragover.prevent
      @drop="onDropHandler(index, $event)"
    >
      <span :title="getTabName(item)">{{ getTabName(item) }}</span>
      <!-- <i class="el-icon-close" @click.stop="handleClose(item, index)"></i> -->
      <el-icon style="margin-left: 10px" @click.stop="handleClose(item, index)"><Close /></el-icon>
    </div>
    <el-popover
      placement="bottom-start"
      :show-arrow="false"
      :offset="1"
      popper-class="hide-menu-popover"
      v-model:visible="hideMenuVisible"
      v-if="allMenuList.length > tabNum1"
      :width="180"
    >
      <ul>
        <li
          v-for="(item, idx) in hideMenuList"
          :key="item.routeUrl"
          :class="['hide-menu-item', currentTab?.routeUrl === item.routeUrl ? 'is-active' : '']"
          :title="getTabName(item)"
          draggable="true"
          @dragstart="onDragStartHandler(tabNum1 + idx, $event)"
          @click="handleChangeTab(item)"
        >
          {{ getTabName(item) }}
        </li>
      </ul>
      <template #reference>
        <div class="tab-more">
          <!-- <i class="el-icon-more"></i> -->
          <el-icon><MoreFilled /></el-icon>
        </div>
      </template>
    </el-popover>
  </div>
  <div v-show="isRightClick" ref="rightClickMenu" class="tab-right-click-list">
    <div style="margin-left: 20px; border-left: 1px solid #cccccc">
      <div class="list-item" style="border-bottom: 1px solid #cccccc" @click="refresh">
        {{ t('main_header_refresh') }}
      </div>
      <div class="list-item" @click="handleClose(rightClickItem.item, rightClickItem.index)">
        {{ t('main_header_close') }}
      </div>
      <div class="list-item" @click="handleAllClose">{{ t('main_header_close_all') }}</div>
      <div
        class="list-item"
        style="border-bottom: 1px solid #cccccc"
        @click="handleCloseExceptThis(rightClickItem.item)"
      >
        {{ t('main_header_close_addition') }}
      </div>
      <div class="list-item" @click="handleCloseRight(rightClickItem.item, rightClickItem.index)">
        {{ t('main_header_close_right') }}
      </div>
      <div class="list-item" @click="handleCloseLeft(rightClickItem.item, rightClickItem.index)">
        {{ t('main_header_close_left') }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { Close, House, MoreFilled } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
// import { onDragStart, onDrop } from 'vue-demi' // 导入拖拽事件处理函数
export default defineComponent({
  name: 'ContainerTabList',
  components: {
    Close,
    House,
    MoreFilled
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    // 使用响应式 t，必须显式 useScope:'global'，否则子组件取到的是 local 作用域，
    // 而项目 setLanguage 只改 i18n.global.locale.value，local 作用域不会感知，
    // 表现为 tab 文案不随语言切换刷新
    const { t } = useI18n({ useScope: 'global' })
    const homeItem = computed(() => ({
      name: t('main_home_home_name'),
      routeUrl: '/'
    }))

    const tabContainer = ref(null)
    // const state = reactive({
    //   visibleTabs: [],
    //   hiddenTabs: [],
    //   dropdownVisible: false
    // })

    const tabNum1 = ref(7)

    // 用 ResizeObserver 监听容器自身宽度变化，覆盖窗口未 resize 但侧边栏折叠/
    // 微应用挂载导致的宽度变化场景；同时保留 window resize 作为兜底
    let resizeObserver = null

    // 下拉按钮固定宽度，与样式 .tab-more 的 width 保持一致
    const MORE_BTN_WIDTH = 42

    onMounted(() => {
      // 等一次 DOM 渲染，避免 offsetWidth=0 时把所有 tab 都塞进下拉
      nextTick(calculateVisibleTabs)
      if (typeof window.ResizeObserver === 'function' && tabContainer.value) {
        resizeObserver = new ResizeObserver(scheduleMeasure)
        resizeObserver.observe(tabContainer.value)
      }
      window.addEventListener('resize', scheduleMeasure)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', scheduleMeasure)
      if (resizeObserver) {
        resizeObserver.disconnect()
        resizeObserver = null
      }
      if (rafId) {
        cancelAnimationFrame(rafId)
        rafId = null
      }
    })

    // 同时依赖 pageList：切换语言时 Header.vue 会重新拉取菜单
    // 并 commit setPageList 替换整个 pageList 数组，以此触发本组件重渲染，
    // 从而让 t(item.name) 重新执行拿到新语言的翻译结果
    const pageList = computed(() => store.state.menu.pageList)
    const allMenuList = computed(() => {
      return store.state.menu.tabList
    })

    // 反查 pageList 拿到对应的 i18n key 再翻译；保留对 pageList 的响应式依赖，
    // 是 tab 标签能跟随语言切换重渲染的核心
    const getTabName = item => {
      const tab = pageList.value.find(el => item.routeUrl?.split('?')[0] === el.routeUrl)
      return t(tab?.name ?? item.name ?? '')
    }

    // console.log(allMenuList)
    // data
    const currentTab = computed(() => {
      return store.state.menu.currentTab
    })
    const hideMenuList = computed(() => {
      return allMenuList.value.slice(tabNum1.value)
    })

    // 处理拖拽开始事件（兼容 Firefox：必须调用 dataTransfer.setData）
    const onDragStartHandler = (index, evt) => {
      draggingIndex.value = index // 将当前拖拽的标签页索引保存到变量中
      if (evt && evt.dataTransfer) {
        try {
          evt.dataTransfer.setData('text/plain', String(index))
          evt.dataTransfer.effectAllowed = 'move'
        } catch (e) {
          // 部分浏览器在拖拽过程中禁止访问 dataTransfer，忽略即可
        }
      }
    }

    // 处理放置拖拽元素事件（支持从下拉框拖出，索引为 tabList 绝对索引）
    const onDropHandler = (index, evt) => {
      // 阻止默认事件，如打开链接
      if (evt && typeof evt.preventDefault === 'function') evt.preventDefault()
      const draggedIndex = draggingIndex.value // 获取拖拽的标签页索引
      if (draggedIndex === null || draggedIndex === undefined) return
      store.commit('menu/changeTabMenu', { draggedIndex, index })
      draggingIndex.value = null
      // 若来源是下拉项，拖入可见区后关闭 popover
      hideMenuVisible.value = false
    }

    const draggingIndex = ref(null) // 保存当前拖拽的标签页索引

    // 计算可见 tab 数量：逐个实测每个 tab 的真实宽度累加，
    // 替代固定 140px 估算，避免短标题时过早收起、长标题时被截断
    const calculateVisibleTabs = () => {
      const container = tabContainer.value
      if (!container) return
      const items = Array.from(container.querySelectorAll('.tab-item'))
      const homeEl = container.querySelector('.home-tab-item')
      const containerWidth = container.offsetWidth
      const homeWidth = homeEl ? homeEl.offsetWidth : 0
      const totalTabs = allMenuList.value.length

      // 全部放得下（含首页 tab，无需预留下拉按钮）时全部展示
      const totalWidth = items.reduce((sum, el) => sum + el.offsetWidth, 0)
      if (homeWidth + totalWidth <= containerWidth) {
        tabNum1.value = totalTabs
        return
      }

      // 放不下时：为下拉按钮预留宽度，再按真实宽度逐个累加
      const available = containerWidth - homeWidth - MORE_BTN_WIDTH
      let used = 0
      let count = 0
      for (const el of items) {
        if (used + el.offsetWidth > available) break
        used += el.offsetWidth
        count++
      }
      tabNum1.value = Math.max(1, count)
    }

    // 用 rAF 合并高频触发（窗口拖拽 resize 等），避免一帧内多次强制布局
    let rafId = null
    const scheduleMeasure = () => {
      if (rafId) return
      rafId = requestAnimationFrame(() => {
        rafId = null
        calculateVisibleTabs()
      })
    }

    // tab 增删/拖拽（addTabMenu/deleteTab 都是原地修改数组，引用不变，
    // 浅 watch 不会触发，必须深度监听）、或切语言导致文案宽度变化后，
    // 等 DOM 渲染完再重新测量
    watch(
      [allMenuList, pageList],
      () => nextTick(scheduleMeasure),
      { deep: true }
    )

    const hideMenuVisible = ref(false)
    const handleChangeTab = (tabItem, isHomeTab) => {
      hideMenuVisible.value = false
      store.commit('menu/changeCurrentTab', tabItem)
      router.push(tabItem.routeUrl)
      // history.pushState(null, null, tabItem.route)
    }
    const handleHomeTab = () => {
      hideMenuVisible.value = false
      store.commit('menu/setCurrentTab', homeItem.value)
      router.push(homeItem.value.routeUrl)
    }
    const handleClose = (item, index) => {
      // 如果标签页列表只有一个标签页
      if (allMenuList.value.length === 1) {
        handleHomeTab() // 切换到主页标签页
        // history.pushState(null, null, '/')
      } else if (currentTab.value?.routeUrl === item.routeUrl) {
        let nextTabIndex = index + 1
        // 如果当前标签页是最后一个标签页，则切换到前一个标签页
        if (nextTabIndex === allMenuList.value.length) nextTabIndex = index - 1
        const nextTab = allMenuList.value[nextTabIndex]
        store.commit('menu/changeCurrentTab', nextTab) // 切换当前标签页
        router.push(nextTab.routeUrl) // 跳转到下一个标签页的路由
        // history.pushState(null, null, nextTab.route)
      }
      store.commit('menu/deleteTab', item.name) // 删除标签页
    }

    const isRightClick = ref(false)
    const rightClickMenu = ref(null)
    const rightClickItem = ref(null)
    // 处理右键点击事件
    const rightClick = (data, tabItem) => {
      isRightClick.value = false // 重置右键点击状态为false
      isRightClick.value = true // 设置右键点击状态为true
      const { clientX, clientY } = data // 获取鼠标点击位置的坐标
      rightClickItem.value = tabItem // 设置右键点击的标签页项
      rightClickMenu.value.style.left = `${clientX - 70}px` // 设置右键菜单的水平位置
      rightClickMenu.value.style.top = `${clientY + 20}px` // 设置右键菜单的垂直位置
      document.addEventListener('click', cancleRightClickMenu) // 监听点击事件，用于取消右键菜单
    }

    const cancleRightClickMenu = () => {
      isRightClick.value = false
      document.removeEventListener('click', cancleRightClickMenu)
    }

    const refresh = () => {
      location.reload()
    }

    const handleAllClose = () => {
      store.commit('menu/resetTab')
      handleHomeTab()
    }

    const setCurrentTab = item => {
      if (currentTab.value?.routeUrl !== item.routeUrl) {
        store.commit('menu/changeCurrentTab', item)
        router.push(item.routeUrl)
      }
    }

    const handleCloseExceptThis = item => {
      store.commit('menu/setTab', [item])
      setCurrentTab(item)
    }

    const handleCloseRight = (item, index) => {
      const beforeTab = allMenuList.value.slice(0, index + 1)
      store.commit('menu/setTab', beforeTab)
      setCurrentTab(item)
    }

    const handleCloseLeft = (item, index) => {
      const afterTab = allMenuList.value.slice(index)
      store.commit('menu/setTab', afterTab)
      setCurrentTab(item)
    }

    return {
      tabContainer,
      homeItem,
      handleHomeTab,
      tabNum1,
      currentTab,
      allMenuList,
      hideMenuList,
      hideMenuVisible,
      rightClickMenu,
      isRightClick,
      rightClickItem,
      handleChangeTab,
      handleClose,
      rightClick,
      refresh,
      handleAllClose,
      handleCloseExceptThis,
      handleCloseRight,
      handleCloseLeft,
      onDropHandler,
      onDragStartHandler,
      // 暴露响应式 t，模板使用 t(...) 代替 $t(...) 以跟随语言切换
      t,
      getTabName
    }
  }
})
</script>

<style lang="scss" scoped>
.tab-list {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  .home-tab-item {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0 20px;
    border-right: $border-grey;
    cursor: pointer;
    font-size: 12px;
    span {
      white-space: nowrap;
    }
    & + .tab-item {
      border-left: none;
    }
    &:hover {
      color: $primary-color;
    }
    &.is-active {
      color: $primary-color;
      font-weight: bold;
      background-color: #ffffff;
    }
  }
  .tab-item {
    @extend .home-tab-item;
    overflow: hidden;
    &.is-hidden {
      // 保留实际宽度供测量，但不占位、不可见、不可交互
      position: absolute;
      visibility: hidden;
      pointer-events: none;
    }
    .el-icon-close {
      margin-left: 10px;
    }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .tab-more {
    flex-shrink: 0;
    width: 42px;
    height: 100%;
    border-right: $border-grey;
    text-align: center;
    line-height: 42px;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.tab-right-click-list {
  position: absolute;
  background-color: #ffffff;
  width: 160px;
  left: 0;
  top: 0;
  list-style: none;
  margin: 0;
  box-sizing: border-box;
  box-shadow: 0 0 4px rgba(200, 200, 200, 0.5);
  border-radius: 5px;
  margin-top: 0 !important;
  z-index: 9999;

  .list-item {
    font-size: 12px;
    padding: 5px 0;
    color: #303133;
    padding-left: 10px;
    box-sizing: border-box;

    &:hover {
      cursor: pointer;
      background-color: #eeeeee;
    }
  }
}
</style>
